<template>
  <b-container id="not-found">
    <div class="content" @keyup.enter="login">
      <div>
        <h1 class="common__main-title">Not found page</h1>
      </div>
      <div class="text-center">
        <b-button pill variant="secondary" :to="{ name: 'Home' }">Home</b-button>
      </div>
    </div>
  </b-container>
</template>

<script lang="ts">
export default {
}
</script>

<style scoped>
#not-found{
  width:100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content{
  min-width:500px;
  min-height: 280px;
  padding: 70px 50px;
  background:#D8E2F3;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 4px 5px 6px #C0C0C0;
}

</style>
